import styled from 'styled-components';
import { themeColors } from 'themes';
// import ResizingIcon from '../../../../../../../../../../icons/resizingScroll.svg'

export const ProcessTableWrapper = styled.div`
  &.process-log {
    gap: 1em;
    width: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(425px, 1fr));
    grid-auto-rows: auto;
    grid-auto-flow: row;
    padding: 15px 15px;
    .customcss {
      display: none;
    }
    .process-section {
      box-shadow: rgb(0 0 0 / 16%) 0px 4px 4px 0px;
      max-height: 340px;
      border-radius: 8px;
      border: 1px solid ${themeColors.lightGrey3};
      opacity: 0px;
      background: rgba(255, 255, 255, 1);
      margin: 5px;
      padding: 10px 0;
      max-width: 550px;
    }
    .process-icon {
      display: flex;
      justify-content: left;
      padding: 0px 0.8rem;
      gap: 0.25rem;
      border-bottom: 1px solid ${themeColors.tableborder};
    }
    .title-text {
      font-size: 14px;
      line-height: 16.4px;
      text-transform: capitalize;
      margin: 8px 0px;
    }
    .process-analysis {
      overflow-y: hidden !important;
      overflow-x: visible !important;
      height: 213px;
      min-height: 250px;

      .table-container-wrapper{
        overflow-x: hidden !important;
        width: 660px;
      }

    }
    .resizer {
      position: absolute;
      top: 0px;
      width: 3px;
      height: 85%;
      background: ${themeColors.lightGrey3};
      cursor: url(/src/icons/resizingScroll.svg) 10 10, col-resize;
      user-select: none;
      touch-action: none;
      border-radius: 40px;
      text-align: center;
    }

    .ltr {
      right: 0!important;
    }

    .rtl {
      left: 0!important;
    }

    .isResizing {
      background: rgba(255, 0, 0, 0.1)!important;
      width: 5px!important;
      height: 85%!important;
      opacity: 1!important;
    }

    th,
    .th {
      position: relative !important;
    }
    .row-hasChildren {
      td.stepdescreng {
        text-align: start;
      }
      td.logtime {
        padding: 8px 0.5rem;
      }
    }
  }
  .gear-icon{
    margin-top: 0rem;
  }
  .data-not-found-text{
    margin-bottom: 0
  }
`;

export const ProcessLogButton = styled.div`
    width: 100%;
    padding-right: 0.75rem;
    display: flex;
    flex-direction: row;
    -webkit-box-pack: center;
    justify-content: end;
    margin: 10px 0px;
    background-color: white;
    
    .close-btn{
    padding: 4px 32px;
    }
}
`;

export const TableFilterContainer = styled.div<{ mb?: string; padding?: string }>`
  display: flex;
  padding: ${({ padding }) => padding || '1.3rem'};
  font-size: 0.875rem;
  justify-content: space-between;
  padding-bottom: ${({ mb }) => mb || '0.5rem'};
  border-bottom: 1px solid ${themeColors.tableborder};
  align-items: center;
  box-shadow: 0px 1px 1px 0px ${(props) => props.theme.colors.lightBlack};
`;

export const DashboardHeader = styled.div`
    .dashboard-header {
      padding: 0px 20px;
    }
  }
`;

export const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent black */
  z-index: 999; /* Make sure it's behind the modal but above other content */
`;

export const ModalContainer = styled.div`
  z-index: 1000; /* Ensure it's above the backdrop */
`;

export const ModalButtonContainer = styled.div`
  width: 100%;
  padding-right: 1.375rem;
  display: flex;
  flex-direction: row;
  justify-content: end;
  background-color: white;

  button {
    margin: 1rem 0.5rem;
    width: auto;
  }
`;